import { TFunction } from 'i18next';
import moment from 'moment';

export const getMomentOfAnniversary = (date: Date, t: TFunction): string => {
  const days = moment(date)
    .startOf('day')
    .diff(moment().startOf('day'), 'days');

  switch (days) {
    case 0:
      return `${t('today')}`;
    case 1:
      return `${t('tomorrow')}`;
    default:
      return t('inNDays', { days });
  }
};
